import * as React from 'react';

import { addDoc, collection, getFirestore } from "firebase/firestore";
import { app } from '../firebaseConfig';

const db = getFirestore(app);

const MESSAGE_RECIPIENT = "charproof.chch@gmail.com"
// const MESSAGE_RECIPIENT = "brett.kieran@hotmail.com" // Dev email

const MESSAGE_SUBJECT = "Charproof Contact Form - New Message"

export default function ContactForm() {
    const [name, setName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [message, setMessage] = React.useState('');
    const [error, setError] = React.useState('');
    

    const handleSubmit = () => {
        if (name === '' || email === '' || phone === '' || message === '') {
            setError('Please fill out all fields');
        } else {
            addDoc(collection(db, "mail"), {
                to: [MESSAGE_RECIPIENT],
                message: {
                    subject: MESSAGE_SUBJECT,
                    text: 'Name: ' + name + '\nEmail: ' + email + '\nPhone: ' + phone + '\nMessage: ' + message + '\n\nDO NOT REPLY TO THIS EMAIL, IT IS AUTOMATICALLY GENERATED.\nPlease reach out to the person directly using their contact details above.\n\n',
                    html: ''
                }
            })

            setName('');
            setEmail('');
            setPhone('');
            setMessage('');

            setError('Message has been sent, thank you');
        }
    }

    return (
        <div className="bottom-padding">
            <span className="content-padding centered bottom-padding">
                Leave your details and we will get back to you
            </span>

            <div className="centered content-padding">
                <div className="contact-us-form">
                    <span className='content'>Name</span>
                    <input name="name" title="Name" className='content' type="text" value={name} onChange={(e) => {
                        setError('');
                        setName(e.target.value)
                    }} />
                    <span className='content'>Email</span>
                    <input name="email" title="Email" className='content' type="text" value={email} onChange={(e) => {
                        setError('');
                        setEmail(e.target.value);
                    }} />
                    <span className='content'>Phone</span>
                    <input name="phone" title="Phone" className='content' type="text" value={phone} onChange={(e) => {
                        setError('');
                        setPhone(e.target.value);
                    }} />
                    <span className='content'>Message</span>
                    <textarea name="message" title="Message" className='content' value={message} onChange={(e) => {
                        setError('');
                        setMessage(e.target.value);
                    }} />

                    {error && <span className="content-bold content-error" style={{ color: error === "Message has been sent, thank you" ? 'green' : '#df2b2b' }}>{error}</span>}

                    <button onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
}